import { ReactElement } from 'react';

import { Tooltip, TooltipLabel } from '@dreryk/react-components';

import { systemActivityTranslationKeys } from '../../translations';

import { StyledAccessReasonCell } from './AccessReasonCell.styled';

type DecisionJustificationCellProps = {
   decisionJustification: string;
};

const DecisionJustificationCell = (props: DecisionJustificationCellProps): ReactElement => {
   return (
      <Tooltip
         testId={'decisionJustification'}
         content={() => (
            <div>
               <TooltipLabel label={systemActivityTranslationKeys.reason} />
               <span>{props.decisionJustification}</span>
            </div>
         )}
      >
         <StyledAccessReasonCell>{props.decisionJustification}</StyledAccessReasonCell>
      </Tooltip>
   );
};
export default DecisionJustificationCell;
